import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class UploadLoyaltyService {

  private baseUrl = 'https://upload.icheck.vn';
  private baseUrl21 = 'https://apis.icheck.vn/upload/image/v1';
  private baseUrl2 = environment.uploadStream;

  constructor(private http: HttpClient) { }

  public create(size: number, metadata: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/upload`, { size, metadata });
  }

  public postImg(body: any): Observable<any> {
    // return this.http.post(`${this.baseUrl2}/raw`, body);
    return this.http.post(`${this.baseUrl2}`, body);
  }

  public postImg1(body: any): Observable<any> {
    // return this.http.post(`${this.baseUrl2}/raw`, body);
    return this.http.post(`${this.baseUrl21}/raw`, body);
  }

  public getFile(id: string): Observable<any> {
    return this.http.get(`${this.baseUrl}/files/${id}`, { params: { fields: ['source', 'metadata'] } });
  }

}
